import type { SendingRequestBundle } from '@domain/types';

export type DocumentFlowRealtimeEventPayload = {
  channel?: string;
  resource: {
    id: fhir.Resource['id'];
    split_ids?: string[];
    from_document_burst?: boolean;
    parent_document_id?: string;
  };
  prefetchedBundle?: SendingRequestBundle;
};

export enum SendingFlowRealTimeEventType {
  CR_UPDATED = 'REALTIME_CR_UPDATED',
  COM_CREATED = 'REALTIME_COM_CREATED',
  COM_UPDATED = 'REALTIME_COM_EVENT_UPDATED',
  TRUSTED_CONTACT_CR_UPDATED = 'REALTIME_TRUSTED_CONTACT_CR_UPDATED',
  ERRORS_COUNT_CHANGED = 'REALTIME_ERRORS_COUNT_CHANGED',
  PUBLIPOSTAGE_CR_CREATED = 'REALTIME_PUBLIPOSTAGE_CR_CREATED',
}

export enum IntegrationFlowRealTimeEventType {
  INTEGRATION_CR_UPDATED = 'REALTIME_INTEGRATION_CR_UPDATED',
  INTEGRATION_COM_CREATED = 'REALTIME_INTEGRATION_COM_CREATED',
  INTEGRATION_COM_UPDATED = 'REALTIME_INTEGRATION_COM_UPDATED',
}

export interface RealTimeEvent<T> {
  eventType: string;
  payload: T;
}
